module.exports = __webpack_public_path__ + "img/circles-modal.9985f6c8.svg";